module.exports = __webpack_public_path__ + "fonts/CiscoSansTTMedium.woff2";